import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Pagination from "../../components/Pagination/Pagination";
import { getWard } from "../../services/ValitanApiService";
import Select from "react-select";
import {
  // confirmDelete,
  createOrUpdateWard,
  getWards as fetchWards,
} from "../Wards/WardService";
import { getDistricts as fetchDistricts } from "../Districts/DistrictService";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { ConfirmDialog } from "primereact/confirmdialog";
import WardUploadModal from "../Wards/WardsUploadModal";
import { enqueueSnackbar } from "notistack";

const WardListTables = () => {
  document.title = "Wards | Valitan IMS";

  const [wards, setWards] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [uploadModalOpen, setUploadModalOpen] = useState(false); // State for upload modal
  const [wardName, setWardName] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [districts, setDistricts] = useState([]);
  const [errors, setErrors] = useState({ wardName: "", district: "" });
  const [editingWardId, setEditingWardId] = useState(null);
  const [paginationInfo, setPaginationInfo] = useState({
    totalElements: 0,
    totalPages: 0,
    pageNumber: 0,
    pageSize: 10,
    sort: {},
  });

  const [selectedFile, setSelectedFile] = useState(null); // State to hold selected file
  useEffect(() => {
    // Fetch regions once when component mounts (or re-fetch only if necessary)
    loadDistricts();
  }, []); // Empty dependency array ensures this only runs on mount

  useEffect(() => {
    // Fetch districts every time pagination info or page size changes
    loadWards(0, paginationInfo.pageSize);
  }, [paginationInfo.pageSize]);

  const loadWards = async (page = 0, size = 10) => {
    const { wards, paginationInfo } = await fetchWards(page, size);
    setWards(wards);
    setPaginationInfo(paginationInfo);
  };

  const loadDistricts = async () => {
    try {
      const response = await fetchDistricts();
      const districtOptions = response.districts.map((district) => ({
        value: district.id,
        label: district.name,
      }));
      setDistricts(districtOptions);
    } catch (error) {
      console.error("Error fetching districts:", error);
      enqueueSnackbar("Error fetching districts:", {variant:"error"})
      setDistricts([]); // Default to an empty array to avoid errors
    }
  };

  const handleNextPage = () => {
    if (paginationInfo.pageNumber < paginationInfo.totalPages - 1) {
      loadWards(paginationInfo.pageNumber + 1, paginationInfo.pageSize);
    }
  };

  const handlePreviousPage = () => {
    if (paginationInfo.pageNumber > 0) {
      loadWards(paginationInfo.pageNumber - 1, paginationInfo.pageSize);
    }
  };

  const openModalForEdit = async (id) => {
    setEditingWardId(id);
    try {
      const response = await getWard(id);
      if (response) {
        const field = response.data.data;
        setWardName(field.name);
        setSelectedDistrict({
          value: field.district.id,
          label: field.district.name,
        });
        setModalOpen(true);
      } else {
        console.error("Ward data is undefined");
      }
    } catch (error) {
      console.error("Error fetching Ward data:", error);
    }
  };

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    if (!modalOpen) {
      setWardName("");
      setSelectedDistrict(null);
      setErrors({
        wardName: "",
        district: "",
      });
      setEditingWardId(null);
    }
  };

  const handleSelectChange = (selectedOption) => {
    setSelectedDistrict(selectedOption);
    setErrors((prevErrors) => ({ ...prevErrors, district: "" })); // Clear the error when a district is selected
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    createOrUpdateWard(
      event,
      wardName, // Pass wardName directly
      selectedDistrict, // Pass selectedDistrict directly
      editingWardId,
      loadWards,
      toggleModal,
      setErrors
    );
  };


  const toggleUploadModal = () => {
    setUploadModalOpen(!uploadModalOpen);
    setSelectedFile(selectedFile); // Clear selected file when closing modal
  };

  const startIndex = paginationInfo.pageNumber * paginationInfo.pageSize + 1;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Wards setup" breadcrumbItem="Wards" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h4 className="card-title mb-0">
                    <Button
                      color="primary"
                      className="add-btn float-end ms-2"
                      id="TooltipTop"
                      onClick={toggleUploadModal}
                    >
                      <i className="ri-upload-cloud-2-line align-bottom me-1"></i> Upload wards
                    </Button>
                    {/* <Button
                      color="primary"
                      className="add-btn float-end"
                      id="TooltipTop"
                      onClick={toggleModal}
                    >
                      <i className="ri-add-line align-bottom me-1"></i> Add
                    </Button> */}
                  </h4>
                </CardHeader>

                <CardBody>
                  <div>
                    <Row className="g-4 mb-3">
                      <Col className="col-sm">
                        <div className="d-flex justify-content-sm-end">
                          <div className="search-box ms-2">
                            <input
                              type="text"
                              className="form-control search"
                              placeholder="Search..."
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>

                    <div className="table-responsive table-card mt-3 mb-1">
                      <table
                        className="table align-middle table-nowrap"
                        id="customerTable"
                      >
                        <thead className="table-light">
                          <tr>
                            <th className="sort" data-sort="email">
                              #
                            </th>
                            <th className="sort" data-sort="email">
                              Ward
                            </th>
                            <th className="sort" data-sort="email">
                              Council
                            </th>
                            <th className="sort" data-sort="action">
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {wards.length > 0 ? (
                            wards.map((ward, index) => (
                              <tr key={ward.id}>
                                <td>{startIndex + index}</td>
                                <td>{ward.name}</td>
                                <td>{ward.council?.name || "N/A"}</td> 
                                <td>
                                  <div
                                    className="btn-group"
                                    role="group"
                                    aria-label="Basic example"
                                  >
                                    <button
                                      id="TooltipTop"
                                      type="button"
                                      className="btn btn-primary btn-sm"
                                      onClick={() =>
                                        openModalForEdit(ward.id)
                                      }
                                    >
                                      <i className="ri-edit-box-line"></i>
                                    </button>
                                    {/* <button
                                      type="button"
                                      onClick={() =>
                                        confirmDelete(ward.id, loadWards)
                                      }
                                      className="btn btn-danger btn-sm"
                                    >
                                      <i className="ri-delete-bin-line"></i>
                                    </button> */}
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" style={{ textAlign: "center" }}>
                                No records found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <Pagination
                      paginationInfo={paginationInfo}
                      handleNextPage={handleNextPage}
                      handlePreviousPage={handlePreviousPage}
                      onPageChange={(pageNumber, pageSize) => loadWards(pageNumber, pageSize)}
                      onPageSizeChange={(newPageSize) => {
                        setPaginationInfo((prev) => ({
                          ...prev,
                          pageSize: newPageSize,
                          pageNumber: 0, // Reset to the first page
                        }));
                      }}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <ConfirmDialog />

      <Modal isOpen={modalOpen} toggle={toggleModal} backdrop={"static"}>
        <ModalHeader toggle={toggleModal}>
          {editingWardId ? "Edit ward" : "Add ward"}
        </ModalHeader>
        <ModalBody>
          <form onSubmit={handleSubmit}>

            <FormGroup>
              <Label for="wardName">Name</Label>
              <Input
                type="text"
                name="wardName"
                id="wardName"
                placeholder="Enter Name"
                value={wardName}
                onChange={(e) => setWardName(e.target.value)}
                invalid={!!errors.wardName}
              />
              {errors.wardName && (
                <div className="invalid-feedback">{errors.wardName}</div>
              )}
            </FormGroup>
            <FormGroup>
              <Label for="district">District</Label>
              <Select
                name="district"
                id="district"
                placeholder="Select a District"
                value={selectedDistrict}
                onChange={handleSelectChange}
                options={districts || []}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: errors.district ? '#dc3545' : base.borderColor,
                    '&:hover': {
                      borderColor: errors.district ? '#dc3545' : base['&:hover'].borderColor,
                    },
                  }),
                }}
              />
              {errors.district && (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {errors.district}
                </div>
              )}
            </FormGroup>
            <Button type="submit" color="primary" className="float-end">
              {editingWardId ? "Update" : "Save"}
            </Button>
          </form>
        </ModalBody>
      </Modal>

      <
        WardUploadModal
        isOpen={uploadModalOpen}
        toggle={toggleUploadModal}
        loadWards={loadWards}
        paginationInfo={paginationInfo}
      />
    </React.Fragment>
  );
};

export default WardListTables;
